import * as BaseIconBadgeHelpers from './helpers';
import * as BaseIconBadgeTokens from './tokens';
import * as BaseIconBadgeUtils from './utils';
export const CFBaseIconBadgeHelpers = BaseIconBadgeHelpers;
export const CFBaseIconBadgeTokens = BaseIconBadgeTokens;
export const CFBaseIconBadgeUtils = BaseIconBadgeUtils;
